import { useContext, useEffect, useState } from 'react'
import { Button, IconButton, Tooltip } from '@mui/material';
import { GridColDef, GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid';
import { Delete, Edit } from '@mui/icons-material';
import useService from '../../hooks/useService';
import { AddressTypes, CUSTOMER_ADDRESSES_FIELDS, ICustomerAddress } from '../../Models/Customer';
import { CustomerContext } from '../../contexts/CustomerContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import { ADDRESS_FORM_CONFIG } from '../../Models/Customer';
import { genId } from '../../utils/helpers';
import DynamicForm, { useDynamicForm } from '../forms/DynamicFormNew';
import Table from '../custom/Table';
import Modal from '../Modals';
import Divider from '../custom/Divider';
import { STATES } from '../../utils/constant';
import { getCityStateFromMts } from '../../services/Customer';
 
type addressType = 'billTo' | 'shipTo'
const alreadyAddedAddresses = (addresses: ICustomerAddress[]):addressType[] => {
    const types: addressType[] = []
    addresses.forEach(address => {
        if(address.type === 'B') types.push('billTo')
        if(address.type === 'D') types.push('shipTo')
    })
return types
}
 
 
const CustomerAddresses = ({ setIndex, submit }: { setIndex: Function, submit: Function }) => {
    const { customerAddresses, setCustomerAddresses } = useContext(CustomerContext)
    const { confirm } = useContext(NotificationContext)
    const [showAddressForm, setShowAddressForm] = useState<boolean | string>(false)
    const [addressType, setAddressType] = useState('')
 
    useEffect(()=>{
    const currentAddresses = alreadyAddedAddresses(customerAddresses)
    if(currentAddresses.includes("billTo") && currentAddresses.includes("shipTo")){
        setAddressType('')
    }else if(currentAddresses.includes('billTo')){
        setAddressType('D')
    }else{
        setAddressType('B')
    }
    },[])
 
    const deleteHandler = (id: string) => {
        confirm({
            handleConfirm: () => setCustomerAddresses(prev => prev.filter(address => address.id != id)),
            text: 'Are you sure you want to delete this address?',
            title: 'Delete Address',
        })
    }
 
    const getAddressColumns = () => {
        let minWidth = 110
        return CUSTOMER_ADDRESSES_FIELDS.map(field => {
            let row: GridColDef<ICustomerAddress> = {
                field: field.id,
                headerName: field.label,
                minWidth: 110,
            }
            switch (field.id) {
 
                case "actions":
                    row.renderCell = params => {
                        return (
                            <>
                                <Tooltip title='Edit'>
                                    <IconButton onClick={() => setShowAddressForm(params.id as string)} ><Edit /></IconButton>
                                </Tooltip>
                                <Tooltip title='Delete'>
                                    <IconButton onClick={() => deleteHandler(params.id as string)} ><Delete /></IconButton>
                                </Tooltip>
                            </>
                        )
                    }
                    break;
                   
                    case 'type':
                        row.renderCell = params =>  params.row.type ? AddressTypes.filter(type => type.value === params.row.type)[0]?.label : ''
            }
            return row
        })
    }
 
    const handleNext = () => {
        setIndex(2)
    }
 
    const handleSubmit = () => {
        submit()
    }
    const handleAddAddress =()=>{
        setShowAddressForm(true)
    }
 
    return (
        <div style={{ padding: '0 10px' }}>
            <Divider />
            <div style={{ overflow: 'hidden' }}>
                <Table columns={getAddressColumns()} rows={customerAddresses} />
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', gap: '10px', marginTop: '20px' }}>
                <Button variant='contained' type='submit' onClick={handleAddAddress} >{`Add ${addressType===''?'':( addressType==='B'? 'Billing' : 'Delivery')} Address`}</Button>
                <Button variant='contained' type='submit' onClick={handleNext} >{'Next'}</Button>
                <Button sx={{ ml: 'auto' }} variant='contained' type='submit' onClick={handleSubmit} >{'Submit'}</Button>
            </div>
            <AddAddress
                open={Boolean(showAddressForm)}
                closeForm={() => setShowAddressForm(false)}
                id={typeof showAddressForm === 'string' ? showAddressForm : ''}
                addressType = {addressType}
            />
        </div>
    )
}
 
 
function AddAddress({ closeForm, id, open, addressType }: { id?: string, open: boolean; closeForm: Function; addressType:string}) {
    const { setCustomerAddresses, customerAddresses,customerConfig } = useContext(CustomerContext)
    const { notify } = useContext(NotificationContext)
    const { execute } = useService()
 
    const { registerForm, setFormData,setField ,formData} = useDynamicForm({
        formConfig: ADDRESS_FORM_CONFIG
    })
 
    const [cities, setCities] = useState('');
 
    async function getstatecity(){
        let stateorcity = "CNIND"
        let MTSStates = []
  let  stateCode = false
 
        const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode}))
         if(data! && MTSStates.length=== 0){
            //@ts-ignore
            for(let i = 0 ; i < data.length ; i++ ){
                //@ts-ignore
                let state = {value:data[i].domain_description, label:data[i].domain_description, code: "25"}
                MTSStates.push(state)
            }
         }
         setField('state', {options:MTSStates })
 
     }
 
   
    // const getFormConfig = () => Boolean(id)
    //     ? ADDRESS_FORM_CONFIG.map(field => ({ ...field, value: customerAddresses.filter(address => address.id === id)[0][field.fieldName as keyof ICustomerAddress] }))
    //     : ADDRESS_FORM_CONFIG
 
    const submitHandler = async(data: ICustomerAddress): Promise<any> => {
        data.zip = Number(data.zip)
        let stateCode = ""
        data.country = "India"
        STATES.forEach((state)=> {
            if(state.value === data.state)
            stateCode = state.code
        })
    let stateCodeFromMaster : any =  await getStateCodeFromMaster(data.state)
 
        data.stateCode = stateCodeFromMaster
        if (Boolean(id)) updateHandler(data)
        else createAddress(data)
 
        notify('Address saved.')
        handleClose()
    }
    async function getStateCodeFromMaster(stateorcity : any){
        let stateCode = true ;
        const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode}))
        console.log(data,"statecodefrommaster")
        //@ts-ignore
       if(data != null) return data[0]?.state_code
     }
 
    const handleClose = () => {
        closeForm()
    };
 
    const createAddress = (data: any) => {
        setCustomerAddresses(prev => ([...prev, { ...data, id: genId() }]))
    }
 
    const updateHandler = (data: any) => {
        setCustomerAddresses(prev => {
            return prev.map(address => address.id === id ? { ...data, id } : address)
        })
    }
 
let citiesFromMaster :any = []
 
    useEffect(() => {
    if(id){
        for(let i = 0; i<cities.length; i++){
            if(id == customerAddresses[i].id){
             
                for(let j = 0; j<cities.length; j++){
                //@ts-ignore
                    if(customerAddresses[i].state == cities[j]?.state){
                        //@ts-ignore
                       setField('city', {options:cities[j].cities })
                    }
                }
               
            }
        }
    }
 
 
     
        if (open && id) setFormData(customerAddresses.filter(address => address.id === id)[0])
        else if (addressType === 'D') {
        setFormData(customerAddresses.filter(address => address.type === 'B')[0])
        // setFormData(prev => ({ ...prev, type:addressType }))
           
}      
        else setFormData({} as ICustomerAddress)
        getstatecity();
    }, [open])
 
 
 
   
   
 
 
    useEffect(() => {
       if(formData.state) {
        getCityFromMaster(formData.state)
     
       }
    }, [formData.state])
   
 
 
   
    async function getCityFromMaster(stateorcity : any){
  let  stateCode = false
        const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode}))
         if(data!){
            let updated_cities = [];
            //@ts-ignore
            for(let i = 0 ; i < data.length ; i++ ){
                //@ts-ignore
                let cities = {value:data[i].domain_description, label:data[i].domain_description, code: i+1}
                updated_cities.push(cities)
            }
            let citiesObject = {
                "state" : stateorcity,
                "cities" : updated_cities
            }
            citiesFromMaster.push(citiesObject)
            setCities(citiesFromMaster)
            setField('city', {options:updated_cities })
         }
    }
   
 
    useEffect(() => {
                    for(let i= 0; i<customerAddresses.length; i++){    
                            getCityFromMaster(customerAddresses[i].state)
                     }
        }, [customerAddresses ,id])
       
 
 
 
       
   
 
    return (
        <Modal open={open} title={Boolean(id) ? 'Edit Address' : 'Add Address'} onClose={closeForm}>
            <DynamicForm onSubmit={submitHandler} submitText='Save' cancelText='Cancel' onCancel={handleClose} {...registerForm()} />
        </Modal>
    );
}
 
export default CustomerAddresses